import { render, staticRenderFns } from "./dropdown_typeahead.vue?vue&type=template&id=bcdbdc5e&scoped=true&"
import script from "./dropdown_typeahead.vue?vue&type=script&lang=ts&"
export * from "./dropdown_typeahead.vue?vue&type=script&lang=ts&"
import style0 from "./dropdown_typeahead.vue?vue&type=style&index=0&id=bcdbdc5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdbdc5e",
  null
  
)

export default component.exports